import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #1e958c 0%, #0b4f6c 40%, #f5f7fb 100%);
`;

export const ContentArea = styled.div`
  width: 100%;
  max-width: 1040px;
  margin: 16px auto 24px;
  padding: 20px 16px 28px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
  display: flex;
  flex-direction: column;
  gap: 18px;
  backdrop-filter: blur(8px);
`;

export const FormItens = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 8px;
`;

export const PageTitle = styled.span`
  display: block;
  text-align: center;
  font-weight: 700;
  font-size: 22px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #1e958c;
  margin: 4px auto 8px;
  width: 100%;
`;

export const ActionsArea = styled.div`
  display: flex;
  width: 100%;
  gap: 24px;
  align-items: stretch;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const DividerAreaLeft = styled.div`
  flex: 1;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
`;

export const DividerAreaRight = styled.div`
  flex: 1.2;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
`;

export const UsersInfo = styled.span`
  text-align: center;
  color: #ab0505;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.4;
  max-width: 90%;

  @media (min-width: 768px) {
    font-size: 15px;
    max-width: 80%;
  }
`;

export const AttachmentsArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;

  > div {
    max-height: 110px;
    overflow-y: auto;
    padding-right: 4px;
    font-size: 13px;
    color: #475569;
  }
`;

export const TitleArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
`;